export default "__VITE_ASSET__DQMui1mP__"